<template>
    <v-dialog v-model="dialog" max-width="400">
        <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
                <v-icon>{{icons.plus}}</v-icon>
                Session
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Start a new Notes Session
            </v-card-title>
            <v-card-text>
                <v-text-field v-model="session.name" label="Name" />
                <v-text-field v-model="session.description" label="Description" />
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="Close()">
                    <v-icon>{{icons.close}}</v-icon> Close
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text @click="saveSession()" :loading="loading">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  export default {
    name: "AddSession",
    components: {},
    data() {
      return {
        dialog: false,
        session: {
          uuid:undefined,
          name: 'Session on ' + new Date().toDateString()+' '+new Date().toLocaleTimeString(),
          description: ''
        },
        loading: false
      }
    },
    computed: {
      ...mapState(['icons'])
    },
    methods: {
      ...mapActions(['get', 'post']),
      async saveSession(){
        this.loading=true
        let res = await this.post({path: 'api/notes/session',body: this.session})
        this.loading=false
        this.$emit('saved',true)
        this.Close()
      },
      newSession(){
        let s = {
          uuid:undefined,
          name: '',
          description: ''
        }
        this.session = Object.keys({}, s)
      },
      Close() {
        this.dialog = false
      }
    }
  }
</script>

<style scoped>

</style>